import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { CancellationsPage } from './pages/cancellations/CancellationsPage';
import { ViewCancellation } from './pages/cancellations/ViewCancellation';
import { CompanyChangesPage } from './pages/company-changes/CompanyChangesPage';
import { ViewCompanyChange } from './pages/company-changes/ViewCompanyChange';

export const FormManagementPage = () => {
  return (
    <Routes>
      {/* begin::Cancellation Routes */}
      <Route
        path="cancellations"
        element={
          <>
            <PageTitle>Cancellations</PageTitle>
            <CancellationsPage />
          </>
        }
      />
      <Route
        path="cancellations/:id/view"
        element={
          <>
            <PageTitle>Cancellations</PageTitle>
            <ViewCancellation />
          </>
        }
      />
      {/* end::Cancellation Routes */}

      {/* begin::Company Change Routes */}
      <Route
        path="company-changes"
        element={
          <>
            <PageTitle>Company Changes</PageTitle>
            <CompanyChangesPage />
          </>
        }
      />
      <Route
        path="company-changes/:id/view"
        element={
          <>
            <PageTitle>Company Changes</PageTitle>
            <ViewCompanyChange />
          </>
        }
      />
      {/* end::Company Change Routes */}

      <Route
        index
        element={<Navigate to="/form-management/cancellations" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/form-management/cancellations" replace />}
      />
    </Routes>
  );
};
